import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ErrorUtil } from 'src/app/_utilities/error';
import { AppComponent } from 'src/app/app.component';

@Component({
    selector: 'app-jo-standalone-email-pdf',
    templateUrl: './jo-standalone-email-pdf.component.html',
    styleUrls: ['./jo-standalone-email-pdf.component.scss'],
    standalone: false
})
export class JoStandaloneEmailPdfComponent implements OnInit {
 translate: any;
emailForm!: FormGroup;
emailPattern = "^[A-Za-z0-9._%+-]+@[a-z0-9.?-]+[\.]+[a-z]{2,}$";
data:any;
emailAddress: any = '';
  constructor(
    private fb: FormBuilder,
    private languageTranslateService: LanguageTranslateService,
    public modalRef : BsModalRef,
     private globalJobordersService: GlobalJobordersService,
     private spinner:NgxSpinnerService,
     private errorUtil: ErrorUtil
  ) { }

   ngOnInit(): void {
    console.log('Modal Data:', this.data);
    this.emailForm = this.fb.group({
      to: ['', [Validators.required, Validators.pattern(AppComponent.emailPattern)]],
      ccEmail: [[]] // array for p-chips
    });

    this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length) {
        this.translate = data;
      }
    });
  }

   isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  submit() {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    let emailArray = [];
 console.log(this.emailAddress.length,'CC Email Array:', this.emailAddress);
     if(this.emailAddress && this.emailAddress.length > 0){
     emailArray = this.emailAddress.split(',').map(email => email.trim());
   
    if (emailArray.length > 3) {
      this.errorUtil.setErrorMessage(400, null ,'Maximum 3 email addresses allowed', 'error',3000);
      return false;
    }
    
    for (const email of emailArray) {
      if (!this.isValidEmail(email)) {
        this.errorUtil.setErrorMessage(400, null ,  this.translate.general.validationFE.invalidEmailFormat, 'error',3000);
        return false;
      }
    }
  }

    const payload = {
      emailList: Array.isArray(this.emailForm.value.to) ? this.emailForm.value.to : [this.emailForm.value.to],
      ccEmailList: emailArray || []
    };
    console.log('SEND EMAIL PAYLOAD', payload);
    this.spinner.show();
    this.globalJobordersService.sendEmailPDF(payload,this.data.jobOrderId).subscribe({
      next: (response) => {
      this.spinner.hide();
      console.log('Email PDF sent successfully:', response);
        this.errorUtil.setErrorMessage(200, null, response.body.message, 'success', 3000);
      
      // handle success, maybe show a message or close modal
      this.modalRef.hide();
      },
      error: (error) => {
      this.spinner.hide();
       this.errorUtil.setErrorMessage(400, null, error.body.error, 'error', 3000);
      // handle error, maybe show an error message
      console.error('Error sending email PDF:', error);
      }
    });
   
  }
}
